import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { homeAction } from "@redux/modules";

// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// React Icons
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Hooks
import useRoleAccess from '@hooks/useRoleAccess';

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Styles
import "./styles.scss";

/**
 * HomeAnnouncement Slider Bileşeni
 * 
 * Anasayfada duyuru slider'ını gösterir.
 * Rol bazlı filtreleme ile kullanıcının rolüne uygun duyuruları gösterir.
 */
const HomeAnnouncement = () => {
  const dispatch = useDispatch();
  const announcementList = useSelector((store) => store.home.announcementList);
  const loginSettings = useSelector((store) => store.auth.loginSettings);
  
  // Rol erişim hook'u
  const { filterAnnouncementsByRole } = useRoleAccess();

  useEffect(() => {
    dispatch(homeAction.getAnnouncementList("homepage"));

    return () => {};
  }, [dispatch]);

  /**
   * Rol bazlı filtrelenmiş duyuru listesi
   * Kullanıcının rolüne uygun duyuruları gösterir
   */
  const filteredAnnouncements = useMemo(() => {
    return filterAnnouncementsByRole(announcementList);
  }, [announcementList, filterAnnouncementsByRole]);

  // Filtrelenmiş duyuru yoksa bileşeni gösterme
  if (!filteredAnnouncements || filteredAnnouncements.length === 0) {
    return null;
  }

  return (
    <section className="announcement-section pb-0">
      <Container>
        <Row>
          <Col>
            <div className="home-swiper-wrapper">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }}
              loop={true}
              autoplay={{
                delay: 10000,
                disableOnInteraction: false,
              }}
              className="mySwiper home-swiper"
            >
              {filteredAnnouncements.map((item, index) => {
                const key = item.id || index;
                // "/" bağlantısı yönlendirme yapılmayacak duyuruları işaret eder
                const hasLink = item.url && item.url !== "/";
                // SwiperSlide, Swiper'ın doğrudan çocuğu olmalıdır. Fragment ile
                // sarmalandığında Swiper slide'ları güvenilir şekilde tanıyamayıp
                // bazı banner'ları göstermeyebiliyordu.
                return (
                  <SwiperSlide key={`announcement-${key}`}>
                    {item?.announcementContentList?.length > 0 &&
                      !hasLink && (
                        <Row className="justify-content-center">
                          <Col xs={12} sm={12}>
                            <img
                              src={item.announcementContentList[0]}
                              className="img-fluid w-100"
                              alt="announcement"
                            />
                          </Col>
                        </Row>
                      )}

                    {item?.announcementContentList?.length > 0 &&
                      hasLink && (
                        <Row className="justify-content-center">
                          <Col xs={12} sm={12} lg={12}>
                            <a
                              href={item.url}
                              target={item.newTab ? "_blank" : "_self"}
                              rel="noreferrer"
                            >
                              <img
                                src={item.announcementContentList[0]}
                                className="img-fluid w-100"
                                alt="announcement"
                              />
                            </a>
                          </Col>
                        </Row>
                      )}
                  </SwiperSlide>
                );
              })}
            </Swiper>
              <div className="swiper-button-next">
                <FaChevronRight style={{ color: `${loginSettings?.blue}` }} />
              </div>
              <div className="swiper-button-prev">
                <FaChevronLeft style={{ color: `${loginSettings?.blue}` }} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default HomeAnnouncement;
